// extracted by mini-css-extract-plugin
module.exports = {"image":"Icon_image__HTkWD","white":"Icon_white__s_fIV","grey":"Icon_grey__yGHWj","dark":"Icon_dark___qV4l","accent":"Icon_accent__79LTk"};